module.exports = __webpack_public_path__ + "static/Month-Overflow-Option-1b9bc4681dff2b31a20d9f3f558e9f72.png";